export const OWNER_ASSETS = 'owner';
export const CREATOR_ID = 'creatorId';
export const LIBRARY_TYPE = 'libraryType';
export const ASSET_TYPE = 'assetType';
export const ASSET_FILE = 'assetFile';
export const ASSETS_LIBRARY_ID = 'assetsLibraryId';
